/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {navigate, ResponseData, showDialog} from '@dvrd/dvr-controls';
import React, {useState} from 'react';
import {useParams} from 'react-router';
import {resetTwoFactor} from "../../../util/requestSender";
import {createErrorMessage, onNavigate} from "../../../util/utils";
import ResetTwoFactor from "./resetTwoFactor";

export default function ResetTwoFactorController() {
    const [confirmed, setConfirmed] = useState(false);
    const [loading, setLoading] = useState(false);
    const {token} = useParams<{ token: string }>();

    if (!token) {
        navigate('/inloggen');
        return null;
    }

    function onChangeConfirmed() {
        setConfirmed(!confirmed);
    }

    function onSubmit() {
        if (!token) return;
        setLoading(true);
        resetTwoFactor({
            token, callback: (data: ResponseData) => {
                if (data.success)
                    showDialog('De tweestapsverificatie is succesvol uitgeschakeld, je kunt nu inloggen met jouw ' +
                        'e-mailadres en wachtwoord.', 'Tweestapsverificatie uitgeschakeld', [{
                        label: 'Oké',
                        onClick: onNavigate('/inloggen')
                    }]);
                else
                    showDialog(createErrorMessage(data.message ?? 'Het uitschakelen van de tweestapsverificatie is ' +
                        'mislukt.'), 'Uitschakelen mislukt')
            }
        })
    }

    return (
        <ResetTwoFactor onChangeConfirmed={onChangeConfirmed} onSubmit={onSubmit} confirmed={confirmed}
                        loading={loading}/>
    );
}